import React from 'react';
import PropTypes from 'prop-types';
import CommonImageCard from "../../CommonImageCard";
import "./index.css";

AttachmentGriView.propTypes = {
    currentMessage: PropTypes.object.isRequired,
};

function AttachmentGriView(props) {

    let displayData = [], difference = 0;
    const length = props.currentMessage.data.length;


    if(length === 1){
        displayData = props.currentMessage.data;
    }else{
        props.currentMessage.data.map((d, index) => {
            if (!((length === (index + 1)) && length % 2 !== 0)) {
                displayData.push(d);
            }
        })
    }
    difference = length - displayData.length;

    let imgLoadingContainer, imgContainerClassName;
    if (length === 1) {
        imgLoadingContainer = "attachment-grid-view-for-image-preview one-image";
        imgContainerClassName = "attachment-grid-view-for-image one-image";
    } else {
        imgLoadingContainer = "attachment-grid-view-for-image-preview more-than-1";
        imgContainerClassName = "attachment-grid-view-for-image more-than-1";
    }

    return (
        <div className="attachment-grid-view-wrapper">
            <div className="attachment-grid-view-floating-box">
                {
                    displayData.map((content, index) => {
                        return (
                            <div key={`attachment-grid-view-${index}`}>
                                <CommonImageCard
                                    pricing={false}
                                    showBroadcasterSection={false}
                                    imgLoadingContainer={imgLoadingContainer}
                                    imgContainerClassName={imgContainerClassName}
                                    openDetail={(content) => {
                                        console.log("openDetail", content)
                                        props.attachmentClicked(props.currentMessage, content)
                                    }}
                                    content={content}
                                />
                                {
                                    (difference > 0 && (index + 1) === displayData.length) &&
                                    <div className="attachment-grid-view-more-item-container" onClick={() => {
                                        props.attachmentClicked(props.currentMessage, null)
                                    }}>
                                        <span>
                                            {`+${difference} More`}
                                        </span>
                                    </div>
                                }
                            </div>
                        )
                    })
                }
            </div>
            <div className="message-text">
                {props.currentMessage.text}
            </div>
        </div>
    );
}

export default AttachmentGriView;